import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PersistConfig, persistReducer } from 'redux-persist';

import { getReduxStorageUtil } from '../../../main/utils/storage/redux-storage.util.ts';

import { ACTIVITY_TRACKING_SLICE_NAME, ActivityTrackingSliceState, Attempt } from './activity-tracking.slice.types.ts';

export const ACTIVITY_TRACKING_SLICE_INITIAL_STATE: ActivityTrackingSliceState = {
  attempts: [],
  correctAttempts: 0,
  incorrectAttempts: 0,
};

const persistKeys: (keyof ActivityTrackingSliceState)[] = ['attempts', 'correctAttempts', 'incorrectAttempts'];

const activityTrackingSlice = createSlice({
  name: ACTIVITY_TRACKING_SLICE_NAME,
  initialState: ACTIVITY_TRACKING_SLICE_INITIAL_STATE,
  reducers: {
    resetActivityTrackingSlice: (_state) => {
      return ACTIVITY_TRACKING_SLICE_INITIAL_STATE;
    },
    registerAttempt: (state, action: PayloadAction<Attempt>) => {
      state.attempts.push(action.payload);
      if (action.payload.isCorrect) {
        state.correctAttempts++;
      } else {
        state.incorrectAttempts++;
      }
    },
  },
});

const persistConfig: PersistConfig<ActivityTrackingSliceState> = {
  key: ACTIVITY_TRACKING_SLICE_NAME,
  storage: getReduxStorageUtil(),
  whitelist: persistKeys,
};

export const { resetActivityTrackingSlice, registerAttempt } = activityTrackingSlice.actions;

export const ActivityTrackingSlice = persistReducer(persistConfig, activityTrackingSlice.reducer);
